<template>
    <div class="action-links">
        <router-link v-if="cambio_de_nivel == 1" :to="{ name: 'finalizar-nivel' }" class="action-link action-link-success">
            <i class="ri-checkbox-circle-line"></i>
            Finalizar nivel
        </router-link>

        <router-link v-else-if="cambio_de_nivel == 2" :to="{ name: 'avanzar-nivel' }" class="action-link action-link-success">
            <i class="ri-arrow-right-up-line"></i>
            Avance de nivel
        </router-link>

        <router-link v-if="certificar" :to="{ name: 'certificado' }" class="action-link action-link-primary">
            <i class="ri-award-line"></i>
            Solicitar mi Certificado ({{ certificar }})
        </router-link>
    </div>
</template>

<script>
import {  mapActions } from 'vuex';
export default {
  name: 'AccionesEstudiante',
  components: {
    
  },
  data() {
    return {        
      cambio_de_nivel: 0,//1:Finalizar Nivel,2:Avanzar Nivel,0:No hacer nada,
      certificar: null
    }
  },
  mounted() {
    this.actualizar();
  },
  methods: {
    ...mapActions({
      fetchCursoFinalizado: 'academico/fetchCursoFinalizado',
      fetchCertificarNivel: 'academico/fetchCertificarNivel',
      fetchDisponibilidad: 'academico/fetchDisponibilidad',
    }),
    actualizar() {
        this.solicitarCertificado();
        this.consultarDisponibilidad();
    },
    consultarDisponibilidad() {
        this.fetchDisponibilidad().then(() => {
            
        }).catch((err) => {
            if (err && err.data && err.data.error && ['No tienes más temas pendientes.', 'No tienes más temas pendientes. Recuerda presentar tu test Versant'].includes(err.data.error)) {
                // Activar cambio de nivel
                this.cursoFinalizado();
            }
        }, false)
    },
    cursoFinalizado() {
      this.fetchCursoFinalizado().then((result) => {
        this.delay_query = false;
        if (result.codigo == 'no') {
          this.cambio_de_nivel = 1;
        } else if (result.codigo == 'inasistencia') {
          this.cambio_de_nivel = 1;
        } else if (result.codigo == 'filled') {
          this.cambio_de_nivel = 0;
        } else if (result.codigo == 'inactivo') {
          this.cambio_de_nivel = 0;
        } else {
          if (result.dato && result.dato.curso_actual && result.dato.curso_actual.nivel_siguiente_id) {
            this.cambio_de_nivel = 0;
          } else {
            this.cambio_de_nivel = 2;
          }
        }
      }).catch((err) => {
        this.delay_query = false;
        console.err(err)
      })
    },
    solicitarCertificado() {
      this.fetchCertificarNivel().then((result) => {
        if (result.codigo === 'ok') {
          this.certificar = result.dato && result.dato.curso_actual ? result.dato.curso_actual.nivel : null;
        } else if (result.codigo === 'solicitado') {
          this.certificar = result.dato && result.dato.nivel ? result.dato.nivel : null;
        }
      })
    }
  }
}
</script>

<style scoped>
/* Enlaces de acción con colores específicos */
.action-links {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.action-link-success {
  background: var(--theme-gradient-secondary);
}

.action-link-success svg {
  color: white;
}

.action-link-primary {
  background: var(--theme-gradient-primary);
}

</style>